import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import ScheduleTimeline from './ScheduleTimeline.js';

const styles = theme => ({
  table: {
    width: '100%',
    display: 'table',
    tableLayout: 'fixed',
  },
  row: {
    display: 'table-row',
  },
  cell: {
    display: 'table-cell',
    padding: 8,
  },
});

class RoomScheduleTable extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      _isMounted: false,

      rowsSelection: {},

      width: window.innerWidth,
      height: window.innerHeight,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.setState({ _isMounted: true });
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    if (this.state.unsubscribe != null) {
      this.state.unsubscribe();
    }
    this.setState({ _isMounted: false });
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  isOtherTimeRowSelected = index => {
    return this.props.rooms.every((room, currentIndex) => {
      if (currentIndex === index) {
        return true;
      }
      var _rowsSelection = this.state.rowsSelection[currentIndex];
      return _rowsSelection === undefined || _rowsSelection.length === 0;
    });
  }

  onSelectTimeRow = (index, selection) => {
    var newRowsSelection = this.state.rowsSelection;
    newRowsSelection[index] = selection;
    this.setState({ rowsSelection: newRowsSelection });
  }

  cleanSelection() {
    console.log("cleanSelection");
  }

  render() {
    // const { classes } = this.props;
    return(
      <div className={this.props.classes.table}>
        <div className={this.props.classes.row}>
        {
          this.props.rooms.map((room, index) => {
            return(
              <div key={index} className={this.props.classes.cell}>
                <ScheduleTimeline
                  room={room}
                  height={this.state.height - 260}
                  isOtherTimeRowSelected={() => this.isOtherTimeRowSelected(index)}
                  onSelectTimeRow={(selection) => this.onSelectTimeRow(index, selection)} />
              </div>
            )
          })
        }
        </div>
      </div>
    );
  }
}

RoomScheduleTable.propTypes = {
  classes: PropTypes.object.isRequired,
  rooms: PropTypes.array.isRequired,
};

export default withStyles(styles)(RoomScheduleTable);
